import React from "react";

export default function UnderConstruction() {
  return (
    <div
      style={{
        display: "flex",
        placeItems: "center",
        flexDirection: "column"
      }}
      className="noselect"
    >
      <h3 style={{ textAlign: "center" }}>
        This page is currently under construction. Please check back soon.
      </h3>
      <br />
      <a href="/" style={{ display: "block", textAlign: "center" }}>
        Go home.
      </a>
    </div>
  );
}
